/**
 * PlanDashboard — the left-side view of the plan under review.
 *
 * Sections:
 *   - CampaignSummary        hero card (advertiser, flight, totals)
 *   - WarningsPanel          blockers + warnings
 *   - LineItemHierarchy      IO → LI table with inline editing
 *
 * FlightTimeline + BudgetDistribution (impressions by tactic/medium) were
 * both removed — didn't add signal over what CampaignSummary +
 * LineItemHierarchy already show.
 */

import React from 'react';
import CampaignSummary from './CampaignSummary';
import WarningsPanel from './WarningsPanel';
import LineItemHierarchy from './LineItemHierarchy';
import './PlanDashboard.css';

const PlanDashboard = ({ plan, warnings, onEditField, onReferenceLineItem }) => {
  if (!plan) {
    return (
      <div className="plan-dashboard-empty">
        Waiting for the agent to load the final plan…
      </div>
    );
  }

  return (
    <div className="plan-dashboard">
      <CampaignSummary plan={plan} />
      <WarningsPanel warnings={warnings} />
      <LineItemHierarchy
        plan={plan}
        onEditField={onEditField}
        onReferenceLineItem={onReferenceLineItem}
      />
    </div>
  );
};

export default PlanDashboard;
